import { useQuery } from '@tanstack/react-query';

import { getNextGamedayOrEvent } from '@/infrastructure/network/data/scheduled-event/next-gameday-event';

interface UseAllEventsQueryParams {
	teamLeagueUuid: string;
	seasonUuid?: string;
	locationUuid?: string;
	teamUuid?: string;
	startDate?: string;
}

export const useAllEventsQuery = ({ teamLeagueUuid, seasonUuid, locationUuid, teamUuid, startDate }: UseAllEventsQueryParams) => {
	return useQuery({
		queryKey: ['ALL_EVENTS', teamLeagueUuid, seasonUuid, locationUuid, teamUuid, startDate],
		queryFn: () =>
			getNextGamedayOrEvent({
				teamLeagueUuid,
				seasonUuid: seasonUuid!,
				locationUuid,
				teamUuid,
				startDate
			}),
		enabled: !!(seasonUuid && teamLeagueUuid)
	});
};
